import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';


import { CasingPlan2dBaseComponent } from '../casing-plan-2d-base.component';
import { SchematicDrawObject } from "./schematic-draw-object.model";
import { WellSegmentModel } from "../../../new-casing-plan/models/casing-plan.model";


@Component({
    selector: 'casing-plan-2d-schematic-horizontal',
    templateUrl: './casing-plan-2d-schematic-base.component.html',
    styleUrls: ['./casing-plan-2d-schematic.component.scss'],
    standalone: false
})
export class CasingPlan2dSchematicHorizontalComponent extends CasingPlan2dBaseComponent implements OnInit {
    public color: string;

    public maxLength: number = 800;
    public minLength: number = this.maxLength / 2;
    shoeHW: number = 20;


    @ViewChild('canvas', { static: true }) canvasRef: ElementRef;
    @Input() casingPlan: any = [];
    @Input() applicationData: any = {};

    ctx: CanvasRenderingContext2D;
    firstKickpoint: number = -1;
    canvasCenterPx: number;
    canvasCenter: number;
    schematicPositionArray: Array<SchematicDrawObject> = [];
    segmentLength: number;
    end:number = 9;
    offset = 20;
    halfOffset = this.offset * .5;
    startX: number = 0;
    startY: number = 0;
    canvasRightPadding: number = 20;
    canvasLeftPadding: number = 10;
    font: string = "12px 'Work Sans'";
    sizeFont: string = "bold 14px 'Work Sans'";
    numberFont: string = "bold 18px 'Work Sans'";
    fontFileStyle: string = "#000000";
    leading: number = 15;
    infoBoxH:number =  105;
    infoBoxW: number = 225;
    infoBoxLeftPadding:number =  5;
    circleRadius: number = 12;
    leaderOffset: number = 3;
    casingEndBottomY: number = 0;
    firstHorizontalInfoBoxTopPosition: number = 0;
    horizontalAfterNumber: number = 0;
    horizontalInfoBoxPadding: number = 15;
    newCanvasHeight: number = 0;
    direction:string = "Horizontal";

    constructor() {
        super();
    }

    ngOnInit(): void {

        //uncomment for production
        this.wellSegments = ((this.casingPlan != null) ? this.casingPlan.wellSegments.filter(w => w.hasData === true && w.position != null && w.position > 0) : []).sort((a, b) => {
            if (a.position < b.position) return -1;
            if (a.position > b.position) return 1;
            return 0;
        });
        //set reusable vars
        this.setVariables();

        //find first kick point
        this.setFirstSegmentKickpoint();

        //do we have a kick point?
        if (this.firstKickpoint != -1) {

            //create array of draw objects
            this.createPositionArray();

            //draw the canvas objects
            this.drawAll();

            //TODO: revisit this method, create the vars before calling createMultipleArcs the first time!
            //  won't have to redraw that way
            //set canvas height to eliminate white-space
            this.setCanvasHeight();

            //clear canvas
            this.ctx.clearRect(0, 0, this.canvasWidth, this.newCanvasHeight);

            //need to redraw everything after the canvas is resized!
            this.drawAll();

            //putt application number in lower right
            this.drawApplicationNumber();

        } else {

            //show canvas alert
            this.showMissingKickpoint();

            //log
            console.log("No kickpoint provided for this horizontal well!");
        }
    }

    /**
     * Only shown if we get to here and there is no kick point for the string
     */
    showMissingKickpoint(): void {
        this.ctx.beginPath();
        this.ctx.font = "18px 'Work Sans'";
        this.ctx.fillStyle = "#ff0000";
        this.ctx.textAlign = "center";
        this.ctx.fillText(this.dataMissingError, this.canvasWidth * .5, this.canvasHeight * .5);
        this.ctx.closePath();
    }

    /**
     * Set reusable vars
     */
    setVariables(): void {
        this.canvasWidth = this.canvasRef.nativeElement.width;
        this.canvasHeight = this.canvasRef.nativeElement.height;
        this.canvasCenter = this.canvasWidth * .5;

        this.segmentLength = this.wellSegments.length; // this.casingPlan.wellSegments.length;

        //these 2 offset the arcs to give more room on the left and bottom
        this.startX = this.canvasCenter + ((this.end * this.offset) - 30);
        this.startY = this.canvasCenter - (.5 * this.end * this.offset);

        this.ctx = this.canvasRef.nativeElement.getContext('2d');

    }

    /**
    * Gets first kick point in segment
    */
    setFirstSegmentKickpoint(): void {
        if (this.wellSegments) {
            for (let segment of this.wellSegments) {
                if (segment.hasAngles) {
                    const top = (segment.casingLength != null) ? segment.casingTop : segment.boreholeTop;
                    const bottom = (segment.casingLength != null) ? segment.casingBottom : segment.boreholeBottom;
                    this.firstKickpoint = (bottom - top) / 2;
                    return;
                }
            }
        }
    }

    /**
     * Creates array of canvas positions and data for drawing
     */
    createPositionArray(): void {

        this.wellSegments.forEach((segment, index) => {
            this.schematicPositionArray.push(this.getDrawObject(segment, index));
        });

        //create vars
        let availableWidth = this.canvasWidth - this.startX - this.canvasRightPadding;
        let availableHeight = this.canvasHeight - this.startY;

        let verticalNumber = this.schematicPositionArray.filter((position) => position.startsBeforeKickpoint == true).length;
        let horizontalNumber = this.schematicPositionArray.filter((position) => position.endsAfterKickpoint == true).length;

        //temp fix for 7 strings that start before the kp, fix this when refactoring 7/8/19
        let offset = verticalNumber != 7 ? 2 : 3;

        let verticalProportion = availableHeight / (verticalNumber + offset);
        let horizontalProportion = availableWidth / (horizontalNumber);

        let hIndex = 0;

       //calculate start & end canvas positions
        this.schematicPositionArray.forEach((position, index) => {
            //VERTICAL
            //start px
            if (position.startsBeforeKickpoint) {
                position.startPx = index * verticalProportion;
            }
            //end px
            if (position.endsBeforeKickpoint) {
                position.endPx = (index + 1) * verticalProportion;
            }

            //HORIZONTAL
            //start px
            if (position.startsAfterKickpoint) {
                position.startPx = hIndex * horizontalProportion;
            }
            if (position.endsAfterKickpoint) {
                position.endPx = (hIndex + 1) * horizontalProportion;
                hIndex++;
            }
        });

    }

    /**
     * Helper, draw object
     * @param segment
     * @param index
     */
    getDrawObject(segment: WellSegmentModel, index: number): SchematicDrawObject {

        let returnDrawObject = new SchematicDrawObject;

        let top: number;
        let bottom: number;
        if (this.hasBorehole(segment)) {
            top = segment.boreholeTop;
            bottom = segment.boreholeBottom;
        } else {
            top = segment.casingTop;
            bottom = segment.casingBottom;
        }

        returnDrawObject.firstDiagramKickpoint = this.firstKickpoint;
        returnDrawObject.topFt = top;
        returnDrawObject.bottomFt = bottom;
        returnDrawObject.startsBeforeKickpoint = top < this.firstKickpoint;
        returnDrawObject.endsBeforeKickpoint = bottom <= this.firstKickpoint;
        returnDrawObject.startsAfterKickpoint = top > this.firstKickpoint;
        returnDrawObject.endsAfterKickpoint = bottom > this.firstKickpoint;
        returnDrawObject.shoeDepthFt = segment.casingShoeDepth;
        returnDrawObject.casingDiameter = segment.casingDiameter;
        returnDrawObject.boreholeDiameter = segment.boreholeDiameter;
        returnDrawObject.casingType = segment.casingType.definition;
        returnDrawObject.segmentIndex = index + 1;
        returnDrawObject.casingLength = segment.casingLength;
        returnDrawObject.boreholeDepth = segment.boreholeDepth;
        returnDrawObject.cementTop = segment.cementTop;
        returnDrawObject.cementVolume = segment.cementVolume;
        return returnDrawObject;
    }

    /**
     * Get draw object using index (different for cement fills and casing lines)
     * @param index
     * @param fill
     */
    getDrawObjectByIndex(index: number, fill: boolean) {
        if (index < this.schematicPositionArray.length) {
            return this.schematicPositionArray[index];
        } else {
            let diff = index - this.schematicPositionArray.length;
            if (fill) {
                return this.schematicPositionArray[this.schematicPositionArray.length - 2 - diff];
            } else {
                return this.schematicPositionArray[this.schematicPositionArray.length - 1 - diff];
            }
        }
    }

    /**
     * Main method to draw objects on canvas
     * */
    drawAll(): void {
        let numberOfLines = this.segmentLength * 2;
        let lineStartEndOFfset = (14 - numberOfLines) * .5;
        let fillIndex = 0;

        this.drawCementOnly(numberOfLines, lineStartEndOFfset, fillIndex);
        this.drawCasingOnly(numberOfLines, lineStartEndOFfset, fillIndex);
        this.drawInfoBoxesOnly(numberOfLines, lineStartEndOFfset, fillIndex);
        this.drawShoesOnly(numberOfLines, lineStartEndOFfset, fillIndex);
    }

    drawCementOnly(numberOfLines:number, lineStartEndOFfset:number, fillIndex:number): void {
        //draw cement fills
        for (let j = lineStartEndOFfset + 2; j < 15 - lineStartEndOFfset; j++) {
            //get position object for this
            let segmentDrawObject = this.getDrawObjectByIndex(fillIndex, true);

            this.ctx.beginPath();

            this.ctx.strokeStyle = "#888888";
            this.ctx.lineWidth = this.offset;

            let cementStart: number = 0;

            if (segmentDrawObject.startsBeforeKickpoint) {
                //move to start of vertical line
                this.ctx.moveTo(this.startX - (j * this.offset) + this.halfOffset, segmentDrawObject.startPx);

                if (segmentDrawObject.endsBeforeKickpoint) {
                    //draw line to stop before curve
                    this.ctx.lineTo(this.startX - (j * this.offset) + this.halfOffset, segmentDrawObject.endPx);

                }

                if (segmentDrawObject.endsAfterKickpoint) {

                    if (j != 8) {

                        //draw vertical line to curve
                        this.ctx.lineTo(this.startX - (j * this.offset) + this.halfOffset, this.startY);

                        //draw curve
                        this.ctx.arcTo(this.startX - (j * this.offset) + this.halfOffset, this.startY + ((j - 1) * this.offset) + this.halfOffset, this.startX, this.startY + ((j - 1) * this.offset) + this.halfOffset, (j * this.offset) - this.halfOffset);

                        //draw horizontal line
                        this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + ((j - 1) * this.offset) + this.halfOffset);


                    }

                }

            }
            if (segmentDrawObject.startsAfterKickpoint) {

                if (j != 8) {
                    //move to start of horizontal
                    this.ctx.moveTo(this.startX + segmentDrawObject.startPx, this.startY + ((j - 1) * this.offset) + this.halfOffset);
                    //draw horizontal line
                    this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + ((j - 1) * this.offset) + this.halfOffset);
                }

            }

            this.ctx.stroke();
            this.ctx.closePath();

            fillIndex++;
        }
        this.ctx.strokeStyle = "black";
    }

    drawShoesOnly(numberOfLines: number, lineStartEndOFfset: number, fillIndex: number): void {

        for (let j = lineStartEndOFfset + 2; j < 15 - lineStartEndOFfset; j++) {

            //get position object for this
            let segmentDrawObject = this.getDrawObjectByIndex(fillIndex, true);


            if (segmentDrawObject.startsBeforeKickpoint) {

                if (segmentDrawObject.endsBeforeKickpoint) {
                    //draw (vertical) shoes
                    if (this.hasValidValue(segmentDrawObject.shoeDepthFt, "number")) {
                        this.addShoe(j, segmentDrawObject.endPx, true);
                    }
                }

                if (segmentDrawObject.endsAfterKickpoint) {

                    if (j != 8) {

                        //draw (horizontal) shoes
                        if (this.hasValidValue(segmentDrawObject.shoeDepthFt, "number")) {
                            this.addShoe(j, segmentDrawObject.endPx, false);
                        }
                    }
                }

            }
            if (segmentDrawObject.startsAfterKickpoint) {

                if (segmentDrawObject.endsAfterKickpoint) {
                    //draw (horizontal) shoes
                    if (this.hasValidValue(segmentDrawObject.shoeDepthFt, "number")) {
                        this.addShoe(j, segmentDrawObject.endPx, false);
                    }

                }
            }

            //do we have shoes on the final string?
            if (j == 8 && this.hasValidValue(segmentDrawObject.shoeDepthFt, "number")) {
                //draw (horizontal) shoes - final string has to be horizontal, because at least 1 kick point is required!
                this.addShoe(j, segmentDrawObject.endPx, false);
            }

            fillIndex++;
        }
    }

    drawCasingOnly(numberOfLines: number, lineStartEndOFfset: number, fillIndex: number): void {
        for (let j = lineStartEndOFfset + 2; j < 15 - lineStartEndOFfset; j++) {

            //get position object for this
            let segmentDrawObject = this.getDrawObjectByIndex(fillIndex, true);

            this.ctx.beginPath();

            this.ctx.strokeStyle = "black";
            this.ctx.lineWidth = 1;

            if (segmentDrawObject.startsBeforeKickpoint) {

                this.moveToStartCasing(j);

                if (segmentDrawObject.endsBeforeKickpoint) {
                    //draw casing
                    this.drawPartialHeightVerticalCasing(j, segmentDrawObject);
                }

                if (segmentDrawObject.endsAfterKickpoint) {

                    if (j != 8) {

                        //draw vertical line to curve
                        this.drawFullHeightVerticalCasing(j);

                        //draw curve
                        this.drawCurveCasing(j);

                        //draw casing
                        this.drawPostKickpointCasing(j, segmentDrawObject);

                    } else {
                        //last string starts before the kick point and ends after the kick point

                        //draw casing
                        this.forceDrawFullHeightVerticalCasing(segmentDrawObject);

                        //draw curve
                        this.forceDrawCurveCasing(j);

                        //draw horizontal
                        this.forceDrawPostKickpointCasing(j, segmentDrawObject);

                        //draw vertical end line
                        this.drawCasingEnd(j, segmentDrawObject);
                    }

                }

            }
            if (segmentDrawObject.startsAfterKickpoint) {

                //draw casing above to ground
                this.moveToStartCasing(j);
                this.drawFullHeightVerticalCasing(j);
                this.drawCurveCasing(j);
                this.drawPostKickpointCasing(j, segmentDrawObject);

                if (j == 8) {
                    //draw lines around the last string
                    this.ctx.moveTo(this.startX + segmentDrawObject.startPx, this.startY + (j * this.offset));
                    this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + (j * this.offset));
                    this.ctx.moveTo(this.startX + segmentDrawObject.startPx, this.startY + ((j - 1) * this.offset));
                    this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + ((j - 1) * this.offset));
                    //draw vertical end line
                    this.drawCasingEnd(j, segmentDrawObject);
                }

            }

            this.ctx.stroke();
            this.ctx.closePath();

            fillIndex++;
        }
    }

    drawInfoBoxesOnly(numberOfLines: number, lineStartEndOFfset: number, fillIndex: number): void {

        for (let j = lineStartEndOFfset + 2; j < 15 - lineStartEndOFfset; j++) {

            //get position object for this
            let segmentDrawObject = this.getDrawObjectByIndex(fillIndex, true);

            this.ctx.beginPath();
            this.ctx.lineWidth = 1;

            if (segmentDrawObject.startsBeforeKickpoint) {

                if (segmentDrawObject.endsBeforeKickpoint) {

                    if (j < 8) {
                        //draw info
                        this.drawInfo(j, segmentDrawObject, true);
                    }

                }

            }

            this.ctx.stroke();

            fillIndex++;
        }

        //draw bottom right info boxes
        this.drawHorizontalSegmentInfoBoxes();


        this.ctx.closePath();
    }

    /**
     * Add shoe (vertical & hor)
     * @param index
     * @param endPx
     * @param vertical
     */
    addShoe(index, endPx, vertical: boolean): void {
        let shoeLeft = new Image();
        let shoeRight = new Image();

        shoeLeft.onload = () => {
            if (vertical && index > 8) {
                this.ctx.drawImage(shoeLeft, this.startX - (index * this.offset), endPx - this.shoeHW, this.shoeHW, this.shoeHW);
            }

            if (!vertical && index > 8) {
                this.ctx.drawImage(shoeLeft, this.startX + endPx - this.shoeHW, this.startY + (index * this.offset) - this.shoeHW, this.shoeHW, this.shoeHW);
            }

            if (!vertical && index == 8) {
                //+1 aligns with end line better
                this.ctx.drawImage(shoeLeft, this.startX + endPx - this.shoeHW + 1, this.startY + (index * this.offset), this.shoeHW, this.shoeHW);
            }
        };

        shoeRight.onload = () => {
            if (vertical && index < 8) {
                this.ctx.drawImage(shoeRight, this.startX - (index * this.offset), endPx - this.shoeHW, this.shoeHW, this.shoeHW);
            }

            if(!vertical && index < 8){
                this.ctx.drawImage(shoeRight, this.startX + endPx - this.shoeHW, this.startY + (index * this.offset) - this.shoeHW, this.shoeHW, this.shoeHW);
            }

            if (!vertical && index == 8) {
                //+1 aligns with end line better
                this.ctx.drawImage(shoeRight, this.startX + endPx - this.shoeHW + 1, this.startY + ((index - 1) * this.offset) - this.shoeHW, this.shoeHW, this.shoeHW);
            }
        };

        shoeLeft.src = vertical ? "../../../assets/images/SVG/shoe-left.svg" : "../../../assets/images/SVG/horizontal-shoe-right.svg";
        shoeRight.src = vertical ? "../../../assets/images/SVG/shoe-right.svg" : "../../../assets/images/SVG/horizontal-shoe-left.svg";
    }

    /**
     * Move to start of casing (different for either side of canvas center)
     * @param index
     */
    moveToStartCasing(index): void {
        if (index < 8) {
            //move to left of cement fill
            this.ctx.moveTo(this.startX - (index * this.offset), 0);
        } else {
            //move to the right of cement fill
            this.ctx.moveTo(this.startX - ((index - 1) * this.offset), 0);
        }
    }

    /**
     * Draw casing from top to somewhere before the kick point
     * @param index
     * @param segmentDrawObject
     */
    drawPartialHeightVerticalCasing(index, segmentDrawObject): void {
        if (index < 8) {
            this.ctx.lineTo(this.startX - (index * this.offset), segmentDrawObject.endPx);
        } else {
            this.ctx.lineTo(this.startX - ((index - 1) * this.offset), segmentDrawObject.endPx);
        }
    }

    /**
     * Draw casing from top to begining of the curve
     * @param index
     */
    drawFullHeightVerticalCasing(index): void {
        if (index != 8) {
            if (index < 8) {
                this.ctx.lineTo(this.startX - (index * this.offset), this.startY);
            } else {
                this.ctx.lineTo(this.startX - ((index - 1) * this.offset), this.startY);
            }
        }
    }

    forceDrawFullHeightVerticalCasing(segmentDrawObject: SchematicDrawObject): void {
        this.ctx.moveTo(this.canvasCenter - (this.offset * .5), segmentDrawObject.startPx);
        this.ctx.lineTo(this.canvasCenter - (this.offset * .5), this.startY);
        this.ctx.moveTo(this.canvasCenter + (this.offset * .5), segmentDrawObject.startPx);
        this.ctx.lineTo(this.canvasCenter + (this.offset * .5), this.startY);
    }

    /**
     * Draws casing for kick point curve regardless of start/end before/after kick point data
     * @param index
     */
    forceDrawCurveCasing(index): void {
        this.ctx.moveTo(this.startX - (index * this.offset), this.startY - 8);
        this.ctx.arcTo(this.startX - (index * this.offset), this.startY + (index * this.offset), this.startX, this.startY + (index * this.offset), index * this.offset);
        this.ctx.moveTo(this.startX - ((index - 1) * this.offset), this.startY - 8);
        this.ctx.arcTo(this.startX - ((index - 1) * this.offset), this.startY + ((index - 1) * this.offset), this.startX, this.startY + ((index - 1) * this.offset), (index - 1) * this.offset);
    }

    /**
     * Draws casing after kick point regardless of start/end before/after kick point data
     * @param index
     * @param segmentDrawObject
     */
    forceDrawPostKickpointCasing(index, segmentDrawObject): void {
        this.ctx.moveTo(this.startX, this.startY + (index * this.offset));
        this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + (index * this.offset));
        this.ctx.moveTo(this.startX, this.startY + ((index - 1) * this.offset));
        this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + ((index - 1) * this.offset));

    }

    /**
     * Draw all casing curves
     * @param index
     */
    drawCurveCasing(index): void {
        if (index != 8) {
            if (index < 8) {
                this.ctx.arcTo(this.startX - (index * this.offset), this.startY + (index * this.offset), this.startX, this.startY + (index * this.offset), index * this.offset);
            } else {
                this.ctx.arcTo(this.startX - ((index - 1) * this.offset), this.startY + ((index - 1) * this.offset), this.startX, this.startY + ((index - 1) * this.offset), (index - 1) * this.offset);
            }
        }
    }

    /**
     * Draw casing after kick point
     * @param index
     * @param segmentDrawObject
     */
    drawPostKickpointCasing(index, segmentDrawObject): void {
        if (index != 8) {
            if (index < 8) {
                this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + (index * this.offset));
            } else {
                this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + ((index - 1) * this.offset));
            }
        }
    }

    /**
     * Draw end cap on longest string
     * @param index
     * @param segmentDrawObject
     */
    drawCasingEnd(index, segmentDrawObject): void {
        this.ctx.moveTo(this.startX + segmentDrawObject.endPx, this.startY + (index * this.offset));
        this.ctx.lineTo(this.startX + segmentDrawObject.endPx, this.startY + ((index - 1) * this.offset));
        this.casingEndBottomY = this.startY + (index * this.offset);
    }

    /**
     * Provides centralized method for drawing/not drawing shapes, labels and summary text
     * @param value - from segment model property
     * @param type - "string" or "number"
     */
    hasValidValue(value, type): boolean {
        if (type == "string") {
            return value != undefined && value != '';
        }
        if (type == "number") {
            return value != undefined && value >= 0;
        }
    }

    /**
     * Vertical string info boxes & leaders
     * @param index
     * @param drawObject
     * @param vertical
     */
    drawInfo(index: number, drawObject: SchematicDrawObject, vertical: boolean): void {

        this.ctx.fillStyle = "#000000";
        this.ctx.font = this.font;

        if (vertical) {
            let textIndentPastCircle = (2 * this.infoBoxLeftPadding) + (2 * this.circleRadius);
            let hPosition = this.canvasLeftPadding + textIndentPastCircle;
            let boxHPosition = this.canvasLeftPadding;

            if (!this.isEven(index)) {
                hPosition = this.canvasWidth + textIndentPastCircle - this.canvasLeftPadding - this.infoBoxW;
                //textAlign = "right"
                boxHPosition = hPosition - textIndentPastCircle;

            }

            this.ctx.textAlign = "left";
            this.ctx.font = this.sizeFont;
            ///top line
            let text: string = "";
            let position = drawObject.endPx + this.leading;
            const increment = 12;
            if (drawObject.boreholeDiameter != null) {
                text = `${drawObject.boreholeDiameter} IN. HOLE`;
                this.ctx.fillText(text, hPosition, position);
                position = position + increment;
            }
            if (drawObject.boreholeDepth != null) {
                text = `${drawObject.boreholeDepth} FT. DEPTH HOLE`;
                this.ctx.fillText(text, hPosition, position);
                position = position + increment;
            }
            if (drawObject.casingDiameter != null) {
                text = `${drawObject.casingDiameter} IN. CASING`;
                this.ctx.fillText(text, hPosition, position);
                position = position + increment;
            }
            if (drawObject.casingLength != null) {
                text = `${drawObject.casingLength} FT. DEPTH CASING`;
                this.ctx.fillText(text, hPosition, position);
                position = position + increment;
            }
            if (drawObject.cementTop != null) {
                text = `${drawObject.cementTop} FT. CEMENT TOP`;
                this.ctx.fillText(text, hPosition, position);
                position = position + increment;
            }
            if (drawObject.cementVolume != null) {
                text = `${drawObject.cementVolume} SACKS CEMENT`;
                this.ctx.fillText(text, hPosition, position);
                position = position + increment;
            }
            this.ctx.font = this.font;
            //bottom line
            this.ctx.fillText("Casing Type: " + drawObject.casingType.replace(" Casing", ""), hPosition, position);
            position = position + increment;
            //draw box outline
            this.ctx.beginPath();
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = "#000000";
            let boxHeight = this.getInfoBoxHeight(drawObject);
            this.ctx.rect(boxHPosition, drawObject.endPx, this.infoBoxW, boxHeight);
            this.ctx.stroke();
            this.ctx.closePath();

            //draw number
            this.ctx.font = this.numberFont;
            this.ctx.textAlign = "center";
            const numberPos = (boxHeight) + (this.circleRadius / 2) + (drawObject.endPx - (boxHeight / 2));
            this.ctx.fillText(drawObject.segmentIndex.toString(), boxHPosition + this.circleRadius + this.infoBoxLeftPadding, numberPos);
            this.ctx.beginPath();
            this.ctx.arc(boxHPosition + this.circleRadius + this.infoBoxLeftPadding, drawObject.endPx + this.circleRadius + ((boxHeight - (2 * this.circleRadius)) * .5), this.circleRadius, 0, 2 * Math.PI);
            this.ctx.stroke();
            this.ctx.closePath();

            //draw horzontal line
            this.ctx.beginPath();

            if (this.isEven(index)) {
                this.ctx.moveTo(boxHPosition + this.infoBoxW, drawObject.endPx + (boxHeight * .5));
                this.ctx.lineTo(boxHPosition + this.infoBoxW + ((index - 1) * this.offset) + 1, drawObject.endPx + (boxHeight * .5))
                this.ctx.lineTo(boxHPosition + this.infoBoxW + ((index - 1) * this.offset) + 1, drawObject.endPx + this.leaderOffset);
            } else {
                this.ctx.moveTo(boxHPosition, drawObject.endPx + (boxHeight * .5));
                this.ctx.lineTo(this.startX - (index * this.offset) + this.halfOffset, drawObject.endPx + (boxHeight * .5))
                this.ctx.lineTo(this.startX - (index * this.offset) + this.halfOffset, drawObject.endPx + this.leaderOffset);
            }


            this.ctx.stroke();

        }
    }

    /**
     * Horizontal string info boxes & leaders
     */
    drawHorizontalSegmentInfoBoxes(): void {
        let availableWidth = this.canvasWidth - this.startX - this.canvasRightPadding;

        let boxHPosition = this.canvasLeftPadding;
        this.horizontalAfterNumber = this.schematicPositionArray.filter((position) => position.endsAfterKickpoint == true).length;
        this.firstHorizontalInfoBoxTopPosition = this.casingEndBottomY + ((this.horizontalAfterNumber - 1) * this.offset);
        let afterKickpointIndex = 0;
        let horizontalStringLength = availableWidth / this.horizontalAfterNumber;
        this.schematicPositionArray.forEach((drawObject, index) => {
            if (drawObject.endsAfterKickpoint) {
                const boxHeight = this.getInfoBoxHeight(drawObject);
                let boxTopY = this.firstHorizontalInfoBoxTopPosition + (afterKickpointIndex * (boxHeight + this.horizontalInfoBoxPadding));
                //draw box
                
                this.ctx.beginPath();
                this.ctx.lineWidth = 1;
                this.ctx.strokeStyle = "#000000";
                this.ctx.rect(boxHPosition, boxTopY, this.infoBoxW, boxHeight);

                //draw horizontal line
                this.ctx.moveTo(boxHPosition + this.infoBoxW, boxTopY + (boxHeight * .5));
                this.ctx.lineTo(this.startX + drawObject.endPx - (.5 * horizontalStringLength), boxTopY + (boxHeight * .5));
                this.ctx.lineTo(this.startX + drawObject.endPx - (.5 * horizontalStringLength), this.firstHorizontalInfoBoxTopPosition + this.leaderOffset - (afterKickpointIndex * this.offset));

                this.ctx.stroke();
                this.ctx.closePath();

                //draw number
                this.ctx.font = this.numberFont;
                this.ctx.textAlign = "center";
                const numberPos = boxTopY + (boxHeight / 2) + (this.circleRadius);
                this.ctx.fillText(drawObject.segmentIndex.toString(), boxHPosition + this.infoBoxLeftPadding + this.circleRadius, numberPos);
                this.ctx.beginPath();
                this.ctx.arc(boxHPosition + this.infoBoxLeftPadding + this.circleRadius, boxTopY + this.circleRadius + ((this.infoBoxH - (2 * this.circleRadius)) * .5), this.circleRadius, 0, 2 * Math.PI);
                this.ctx.stroke();
                this.ctx.closePath();

                this.ctx.textAlign = "left"
                let textLeft = boxHPosition + (2 * this.infoBoxLeftPadding) + (2 * this.circleRadius);
                //draw text
                this.ctx.font = this.sizeFont;
                ///top line
                let text: string = "";
                let position = boxTopY + this.horizontalInfoBoxPadding;
                const increment = 12;
                if (drawObject.boreholeDiameter != null) {
                    text = `${drawObject.boreholeDiameter} IN. HOLE`;
                    this.ctx.fillText(text, textLeft, position);
                    position = position + increment;
                }
                if (drawObject.boreholeDepth != null) {
                    text = `${drawObject.boreholeDepth} FT. DEPTH HOLE`;
                    this.ctx.fillText(text, textLeft, position);
                    position = position + increment;
                }
                if (drawObject.casingDiameter != null) {
                    text = `${drawObject.casingDiameter} IN. CASING`;
                    this.ctx.fillText(text, textLeft, position);
                    position = position + increment;
                }
                if (drawObject.casingLength != null) {
                    text = `${drawObject.casingLength} FT. DEPTH CASING`;
                    this.ctx.fillText(text, textLeft, position);
                    position = position + increment;
                }
                if (drawObject.cementTop != null) {
                    text = `${drawObject.cementTop} FT. CEMENT TOP`;
                    this.ctx.fillText(text, textLeft, position);
                    position = position + increment;
                }
                if (drawObject.cementVolume != null) {
                    text = `${drawObject.cementVolume} SACKS CEMENT`;
                    this.ctx.fillText(text, textLeft, position);
                    position = position + increment;
                }
                this.ctx.font = this.font;
                //bottom line
                this.ctx.fillText("Casing Type: " + drawObject.casingType.replace(" Casing", ""), textLeft, position);

                afterKickpointIndex++;
            }
        });

    }


    getInfoBoxHeight(obj: SchematicDrawObject): number {
        let height = this.infoBoxH;
        let dataPoints = 0;
        if (obj.casingType != null) dataPoints += 1;
        if (obj.boreholeDepth != null) dataPoints += 1;
        if (obj.boreholeDiameter != null) dataPoints += 1;
        if (obj.casingDiameter != null) dataPoints += 1;
        if (obj.casingLength != null) dataPoints += 1;
        if (obj.cementTop != null) dataPoints += 1;
        if (obj.cementVolume != null) dataPoints += 1;
        if (dataPoints > 0 && dataPoints < 7) dataPoints += 1;
        height = (dataPoints > 0) ? dataPoints * 15 : height;
        return height;
    }
    /**
     * Trims extra white space at the bottom of the canvas
     */
    setCanvasHeight(): void {
        this.newCanvasHeight = this.firstHorizontalInfoBoxTopPosition + (this.horizontalAfterNumber * (this.infoBoxH + this.horizontalInfoBoxPadding)) - this.canvasLeftPadding;
        this.canvasRef.nativeElement.height = this.newCanvasHeight;
    }

    drawApplicationNumber(): void {
        this.ctx.textAlign = "right";
        this.ctx.font = this.font;
        this.ctx.fillText("Application Number: " + this.applicationData.applicationNumber, this.canvasWidth - this.canvasRightPadding, this.newCanvasHeight);
    }

    /**
     * Helper
     * @param index
     */
    isEven(index) {
    return index % 2 == 0;
    }
}
